import { render, staticRenderFns } from "./SidebarOptions.vue?vue&type=template&id=0e072dfc&scoped=true&"
import script from "./SidebarOptions.vue?vue&type=script&lang=ts&"
export * from "./SidebarOptions.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarOptions.vue?vue&type=style&index=0&id=0e072dfc&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e072dfc",
  null
  
)

export default component.exports